import { API_URL } from '@dynameat/constants';

export const MENU_GRID_CONFIGURATION_ENDPOINT = (menuGridConfiguration = '') => `${API_URL()}/${process.env.VUE_APP_MENU_GRID_CONFIGURATION}/${menuGridConfiguration}`;
export const MENU_GRID_ITEM_ENDPOINT = (menuGridItem = '') => `${API_URL()}/${process.env.VUE_APP_MENU_GRID_ITEM}/${menuGridItem}`;
export const MENU_GRID_ITEM_CONFIGURATION = (menuGridItemConfiguration = '') => `${API_URL()}/${process.env.VUE_APP_MENU_GRID_ITEM_CONFIGURATION}/${menuGridItemConfiguration}`;
